import { render, staticRenderFns } from "./LeadProduct.vue?vue&type=template&id=38e8275f"
import script from "./LeadProduct.vue?vue&type=script&lang=js"
export * from "./LeadProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports